<template>
  <div class="dashboard">
    <Loader :loading="loading" loading-text="please wait..." />
    <main class="page-content">
      <header class="welcome-text mb-3 ml-2 ml-lg-0">
        Apply for Loan
        <span class="transfer-option"></span>
      </header>

      <div class="statement-container">
        <!-- back-home -->
        <div class="back-home" style="cursor:pointer" @click="$router.go(-1)">
          <span>
            <i class="fal fa-long-arrow-left icon"></i>
          </span>
          <!-- <span><i class="fal fa-arrow-left icon fa-2x"></i></span> -->
        </div>

        <!-- form start -->
        <h6>Loan Information</h6>

        <ValidationObserver v-slot="{ passes }">
          <form @submit.prevent="passes(postLoan)">
            <div class="tab-contents">
              <div class="form-row">
                <div class="col-md-5 mb-3 mt-3">
                  <ValidationProvider
                    name="applyProduct"
                    rules="required|min_value:1000|max_value:1000000"
                    v-slot="{ errors }"
                  >
                    <label for="v">
                      Loan Product
                      <span class="text-danger">*</span>
                    </label>
                    <select
                      v-model="applyProduct"
                      class="browser-default custom-select"
                      placeholder="title"
                      name="title"
                      id="title"
                      value="applyProduct"
                    >
                      <option value="Mr">--Select Loan Product--</option>
                      <option value="Mrs">--Select Loan Product--</option>
                      <option value="Ms">--Select Loan Product--</option>
                    </select>

                    <span style="font-size:13px; color:red">
                      <span v-if="errors[0]">
                        <i class="fas fa-ban"></i>
                      </span>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="form-row first">
                <div class="col-md-5 mb">
                  <ValidationProvider
                    name="applyAmount"
                    rules="required|min_value:1000|max_value:1000000"
                    v-slot="{ errors }"
                  >
                    <label for>
                      Loan Amount
                      <span class="text-danger">*</span>
                    </label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="inputGroupPrepend">&#8358;</span>
                      </div>
                      <vue-numeric
                        v-model="applyAmount"
                        class="form-control"
                        name="Loan Amount"
                        placeholder="0"
                        separator=","
                      ></vue-numeric>
                    </div>
                    <br />
                    <span style="font-size:13px; color:red">
                      <span v-if="errors[0]">
                        <i class="fas fa-ban"></i>
                      </span>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                 
                </div>

                <div class="col-md-2"></div>

                <div class="col-md-5 mb">
                  <label for="validationCustom02">
                    Loan Tenor
                    <span class="text-danger">*</span>
                  </label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text"
                        style="cursor:pointer"
                        v-on:click="minus"
                        id="inputGroupPrepend"
                      >-</span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      style="background:whitesmoke"
                      disabled
                      v-model.number="applyTenor"
                      id="validationCustom02"
                      placeholder="Duration (months)"
                      required
                    />
                    <div class="input-group-append">
                      <span
                        class="input-group-text"
                        style="cursor:pointer"
                        v-on:click="plus"
                        id="inputGroupPrepend"
                      >+</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="form-row thir mb-3"></div> -->
<!-- 
              <div class="form-row">
                <div class="col-md-5 mb-3">
                  <ValidationProvider
                    name="Account_Number"
                    rules="required|numeric|min:10|max:10"
                    v-slot="{ errors }"
                  >
                    <label for class="d-inline">
                      Account Number
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      disabled
                      name="Account_Number"
                      v-model="account"
                      type="text"
                      class="form-control"
                    />
                    <span style="font-size:13px; color:red">
                      <span v-if="errors[0]">
                        <i class="fas fa-ban"></i>
                      </span>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>

                <div class="col-md-2"></div>

                <div class="col-md-5">
                  <ValidationProvider name="Bank_Name" rules="required" v-slot="{ errors }">
                    <label for class="d-inline">
                      Bank
                      <span class="text-danger">*</span>
                    </label>
                    <select class="browser-default custom-select" name="Bank_Name" v-model="bank">
                      <option>Choose</option>
                      <option selected value="asset matrix">Asset Matrix</option>
                    </select>
                    <span style="font-size:13px; color:red">
                      <span v-if="errors[0]">
                        <i class="fas fa-ban"></i>
                      </span>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div> -->

              <div class="form-row">
                <div class="col-md-5 mt-3 loanPurpose">
                  <ValidationProvider name="applyPurpose" rules="required" v-slot="{ errors }">
                    <label for="exampleFormControlTextarea1">
                      Loan Purpose
                      <span class="text-danger">*</span>
                    </label>
                    <textarea
                      v-model="applyPurpose"
                      name="applyPurpose"
                      class="form-control text-area"
                      id="exampleFormControlTextarea1"
                      rows="3"
                    ></textarea>
                    <span style="font-size:13px; color:red">
                      <span v-if="errors[0]">
                        <i class="fas fa-ban"></i>
                      </span>
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div class="col-md-2"></div>
                <!-- loan interest -->
                <div class="col-md-5 mb-3">
                        <ValidationProvider
                          name="applyInterest"
                          rules="required|max 30"
                          v-slot="{ errors }"
                        >
                          <label for="employeraddress">Loan Interest %</label>
                          <input
                          
                            v-model="applyInterest"
                            name="applyInterest"
                            type="number"
                            class="form-control"
                            id="applyInterest"
                          />
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
              
              </div>
             </div>
             <div class="h6 mt-5">
             <h6> Guarantor Information </h6>
             </div>
             <div class="row">
             <div class="form-group col-md-5 col-sm-12">
                        <ValidationProvider
                          name="gurantorTitle"
                          rules="required"
                          ref="title"
                          v-slot="{ errors }"
                        >
                          <label for="title">
                            Title
                            <span class="text-danger">*</span>
                          </label>

                          <select
                            v-model="guarantorTitle"
                            type="text"
                            name="guarantorTitle"
                            class="browser-default custom-select mb-sm-0"
                            id="guarantorTitle"
                          >
                            <option value="mr">Mr</option>
                            <option value="mrs">MRS</option>
                            <option value="ms">MS</option>
                          </select>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      <!--  Name -->
                      <div class="col-md-2"></div>
                      <div class="div3i col-md-5 mb-3">
                        <ValidationProvider
                          name="applyGuarantor"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label for="v">
                            Name
                            <span class="text-danger">*</span>
                          </label>
                          <div class="input-group">
                            <input
                              type="text"
                              v-model="applyGuarantor"
                              class="form-control"
                              placeholder
                              name="applyGuarantor"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      </div>
                      <!-- Phone Number -->
                    <div class="row">
                      <div class="col-md-5 mb-3">
                        <ValidationProvider
                          name="applyPhone"
                          rules="required|min:11"
                          v-slot="{ errors }"
                        >
                          <label for="v">
                            Phone Number
                            <span class="text-danger">*</span>
                          </label>
                          <div class="input-group">
                            <input
                              type="number"
                              v-model="applyPhone"
                              class="form-control"
                              placeholder
                              name="applyPhone"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      <div class="col-md-2"></div>
                      <!-- Address -->
                      <div class="col-md-5 mb-3">
                        <ValidationProvider
                          name="applyAddress"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label for="v">
                            Address
                            <span class="text-danger">*</span>
                          </label>
                          <div class="input-group">
                            <input
                              type="text"
                              v-model="applyaddress"
                              class="form-control"
                              placeholder
                              name="name"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                    </div>
                     <!-- Email -->
                    <div class="row">
                      <div class="col-md-5 mb-3">
                        <ValidationProvider
                          name="applyEmail"
                          rules="required|email"
                          v-slot="{ errors }"
                        >
                          <label for="v">
                            Email
                            <span class="text-danger">*</span>
                          </label>
                          <div class="input-group">
                            <input
                              type="email"
                              v-model="applyEmail"
                              class="form-control"
                              placeholder
                              name="applyEmail"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      <div class="col-md-2"></div>
                      <!-- employment status -->
                      <div class="form-group col-md-5 col-sm-12">
                        <ValidationProvider
                          name="applyEmployment"
                          rules="required"
                          ref="employment"
                          v-slot="{ errors }"
                        >
                          <label for="employment">Employment Status</label>

                          <select
                            v-model="applyEmployment"
                            type="text"
                            name="applyEmployment"
                            class="browser-default custom-select mb-3 mb-sm-0"
                            id="applyEmployment"
                          >
                            <option value="Employed">Employed</option>
                            <option value="Self-Employed">Self-Employed</option>
                            <option value="Unemployed">Unemployed</option>
                          </select>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <!-- Employer -->
                        <div class="row">
                      <div class="form-group col-md-5 col-sm-12">
                        <ValidationProvider
                          name="applyEmployer"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label for="employername">Employer</label>
                          <input
                            v-model="applyEmployer"
                            name="applyEmployer"
                            type="text"
                            class="form-control"
                            id="applyEmployer"
                          />
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      <div class="col-md-2"></div>
                      <!-- Employer Address -->
                      <div class="col-md-5 mb-3">
                        <ValidationProvider
                          name="applyEmpaddress"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <label for="employeraddress">Employer Address</label>
                          <input
                            v-model="applyEmpaddress"
                            name="applyEmpaddress"
                            type="text"
                            class="form-control"
                            id="applyEmpaddress"
                          />
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      </div>
                   <div class="h6 mt-5">
             <h6> Collateral Information </h6>
             </div> 
                    
            
        <div class="row">
        <div class="col-md-5 mb-3">
                        <ValidationProvider name="applyCollateral" v-slot="{ errors }">
                          <label for="v">Type of Collateral</label>
                          <select
                            v-model="applyCollateral"
                            class="browser-default custom-select mb-3 mb-sm-0"
                            placeholder="collateral"
                            name="applyCollateral"
                            id="type"
                          >
                            <option value="type">Type</option>
                            <option value="type">Type</option>
                            <option value="type">Type</option>
                          </select>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      <div class="col-md-2"></div>
                      <div class="col-md-5 mb-3">
                        <ValidationProvider name="nameCollateral" v-slot="{ errors }">
                          <label for="v">Name of Collateral</label>
                          <select
                            v-model="nameCollateral"
                            class="browser-default custom-select mb-3 mb-sm-0"
                            placeholder="collateral"
                            name="collateral"
                            id="name"
                          >
                            <option value="name">Name of Collateral</option>
                            <option value="name">Name of Collateral</option>
                            <option value="name">Name of Collateral</option>
                          </select>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <!-- model -->
                    <div class="row">
                      <div class="col-md-5 mb-3">
                        <ValidationProvider name="applyModel" v-slot="{ errors }">
                          <label for="v">Model</label>
                          <div class="input-group">
                            <input
                              type="text"
                              v-model="applyModel"
                              class="form-control"
                              placeholder
                              name="applyModel"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                      <div class="col-md-2"></div>
                      <!--Date of Purchase -->
                      <div class="col-md-5 mb-3">
                        <ValidationProvider name="applypurchase" v-slot="{ errors }">
                          <label for="v">Purchase Date</label>
                          <div class="input-group">
                            <input
                              type="text"
                              v-model="applyPurchase"
                              class="form-control"
                              placeholder
                              name="applyPurchase"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <!-- Current Value -->
                    <div class="row">
                      <div class="col-md-5 mb-3">
                        <ValidationProvider name="applyValue" v-slot="{ errors }">
                          <label for="v"> Value</label>
                          <div class="input-group">
                            <input
                              type="text"
                              v-model="applyValue"
                              class="form-control"
                              placeholder
                              name="applyValue"
                            />
                          </div>
                          <span style="font-size:13px; color:red">
                            <span v-if="errors[0]">
                              <i class="fas fa-ban"></i>
                            </span>
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                     
                      <div class="col-md-6 mb-3">
                 </div>
                </div>
                
             <div class="d-flex mt-3 justify-content-start">
              <button
                class="btn btn-primary"
                type="submit"
                @click="showSubmit = true"
              >Create Loan</button>
             </div>
            </form>
        </ValidationObserver>

        <!-- success modal -->
        <b-modal hide-footer v-model="showSubmit">
          <div class="modal-container text-center">
            <p class="welcome-text">Loan Created Successfully</p>

            <div>
              <img
                src="../../../assets/images/payment-success.png"
                class="img-fluid"
                width="100px"
                alt
              />
            </div>

            <div>
              <button class="btn btn-primary px-4 mt-4" @click="modalShow = false">Continue</button>
            </div>
          </div>
        </b-modal>
      </div>
    </main>
  </div>
</template>

<script>
import VueNumeric from "vue-numeric";
import { clientService } from "../../../services/ClientServices/client.services";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Loader from "../../../utils/vue-loader/loader.vue";
//import { mapState } from "vuex";
export default {
  name: "Apply",
  components: {
    ValidationObserver,
    ValidationProvider,
    Loader,
    VueNumeric
  },
  data() {
    return {
    applyProduct:"",
     applyAmount: 0,
     applyTenor: 0,
      applyPurpose: "",
      applyInterest: 0,
      guarantorTitle: "",
      applyGuarantor:"",
      applyPhone:0,
      applyAddress:"",
      applyEmail:"",
      applyEmployment:"",
      applyEmployer:"",
      applyEmpaddress:"",
      applyCollateral:"",
      nameCollateral:"",
      applyModel:"",
      applyPurchase:"",
      applyValue:"",
      showSubmit:false,
      loading: false
    };
  },
  methods: {
    minus() {
      if (this.tenor <= 0) return;
      this.tenor = this.tenor - 1;
    },
    plus() {
      if (this.tenor >= 6) return;
      this.tenor = this.tenor + 1;
    },
    //Post Loan
    async postLoan() {
      this.loading = true;
      await clientService
        .postLoan({
          amount: this.amount,
          tenor: this.tenor,
          account: this.account,
          purpose: this.loanPurpose,
          bank: this.bank
        })
        .then(res => {
          this.$toastr.s(res.message, "Posted Succesfully");
          this.$router.push("/Loan");
        })
        .catch(err => {
          this.$toastr.e(err.message || err, "Failed!");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-primary {
  background: $main-color;
  border: 1px solid $main-color;
  font-family: $SourceSansPro-Regular;
  width: 200px;
}

.back-home {
  width: 170px;
}
h6{
    padding-top: 10px;
    font-family: $SourceSansPro-Regular;
}
</style>
